<template>
<span>
<img
  :width="size"
  :height="size"
  :src="image" alt="">
</span>
</template>

<script>
export default {
  name: 'countryFlag',
  props: {
    size: {
      type: Number,
      default: 512,
    },
    image: {
      type: String,
      default: 'img/flags/ukraine.svg',
    },
  },
};
</script>

<style scoped>

</style>
